import type { TechFeatureType } from '@/domains/novelty-check-report/types';
import type { FinalResult } from './search-novelty-result-api';

/**
 * 更新查新相似列表请求体
 */
export interface UpdateNoveltySimilarListRequest {
    /**
     * 任务ID
     */
    task_id: string;
    /**
     * 查新相似列表
     */
    final_result: UpdateNoveltySimilarFinalResultDto[];
    /**
     * 是否为专利初筛阶段,传true,则后端不会把当前的任务状态改为
     */
    is_patent_confirm?: boolean;
}


export interface UpdateNoveltySimilarFinalResultDto {
    /**
     * 专利ID
     */
    patent_id: string;
    /**
     * 特征
     */
    features: UpdateNoveltySimilarFeatures[];
    /**
     * 是否选中
     */
    selected: boolean;
    /**
     * 是否为最相似
     */
    most_similar: boolean;
}

export interface UpdateNoveltySimilarFeatures {
    /**
     * 对比特征
     */
    comparison_feature: string;
    /**
     * 技术特征
     */
    tech_feature: string;
    /**
     * 是否相似
     */
    similar: boolean;
    /**
     * 特征类型
     */
    type: TechFeatureType;
    /**
     * 模型输出的原始特征类型文本
     */
    original_type: string;
    /**
     * 特征类型原因
     */
    reason: string;
}

export type UpdateNoveltySimilarListResponse = FinalResult[];

/**
 * 更新查新相似列表请求
 */
export interface UpdateNoveltySimilarListApi {
    /**
     * 更新查新相似列表
     * @param request 更新查新相似列表请求
     */
    updateNoveltySimilarList(request: UpdateNoveltySimilarListRequest): Promise<UpdateNoveltySimilarListResponse>;
}

export const UpdateNoveltySimilarListApi = Symbol('UpdateNoveltySimilarListApi');
